import React, { useEffect } from 'react';
import { Box, Card, CardContent, Typography, Grid, Button, CircularProgress, Alert, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import useDataFetch, { usePostDataFetch } from '../../utils/useDataFetch';

const AdminDashboard = () => {
    const { data: statsData, isLoading: statsLoading } = useDataFetch({ url: '/admin/stats' });
    const { data: tableData, error: tableError, isLoading: tableLoading, refetch } = useDataFetch({ url: '/admin/data' });
    const { postData: manageUser } = usePostDataFetch();

    const handleAction = async (type, id, action) => {
        if (!window.confirm(`Möchtest du diese Aktion (${action}) wirklich ausführen?`)) return;

        if (type === 'user') {
            await manageUser({ url: `/admin/user/${id}`, aBody: { action }, skipAuth: false });
        }
        refetch(); // Refresh Daten nach Aktion
    };

    if (statsData?.success === false && statsData?.message) {
        return <Alert severity="error" sx={{ m: 5 }}>Zugriff verweigert: {statsData.message}</Alert>;
    }

    return (
        <Box sx={{ p: { xs: 2, md: 5 } }}>
            <Typography variant="h4" gutterBottom>Super-Admin Dashboard</Typography>

            {/* KPIs */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Card><CardContent><Typography variant="h6">Gesamt Nutzer</Typography><Typography variant="h3">{statsData?.stats?.users || 0}</Typography></CardContent></Card>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Card><CardContent><Typography variant="h6">Gesamt Teams</Typography><Typography variant="h3">{statsData?.stats?.teams || 0}</Typography></CardContent></Card>
                </Grid>
            </Grid>

            {/* Tabellen */}
            <Grid container spacing={4}>
                <Grid size={{ xs: 12 }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Alle Nutzer</Typography>
                            {tableLoading ? <CircularProgress /> : (
                                <Box sx={{ overflowX: 'auto' }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>ID</TableCell>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Rolle</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Aktionen</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableData?.users?.map((u) => (
                                                <TableRow key={u.id}>
                                                    <TableCell>{u.id}</TableCell>
                                                    <TableCell>{u.first_name} {u.last_name}</TableCell>
                                                    <TableCell>{u.role}</TableCell>
                                                    <TableCell color={u.is_banned > 0 ? "error" : "success"}>{u.is_banned > 0 ? 'Gesperrt' : 'Aktiv'}</TableCell>
                                                    <TableCell>
                                                        {u.is_banned > 0 ? (
                                                            <Button size="small" color="success" onClick={() => handleAction('user', u.id, 'unban')}>Entsperren</Button>
                                                        ) : (
                                                            <Button size="small" color="warning" onClick={() => handleAction('user', u.id, 'ban')}>Sperren</Button>
                                                        )}
                                                        <Button size="small" color="error" onClick={() => handleAction('user', u.id, 'delete')}>Löschen</Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AdminDashboard;
